export default __webpack_public_path__ + "static/media/malay_icon.3de75c5f.png";